import { Modal } from "react-bootstrap";
import CustomValuesHook from "../../../Hooks/customValuesHook";
import { ErrorToast, InfoToast } from "../../../shared";
import { deleteSensitiveWord } from "../../../api/requestAxios/sensitiveWord";
import { CloseIcon } from "../../../assets/images/svg/close";


type Props = {
  val: any;
  setVal: Function;
  item: any;
  getData: Function;
};
const RemoveWord = ({ val, setVal, item, getData }: Props) => {
  const [param, setParam] = CustomValuesHook({
    loading: false,
  });
  const handleClose = () => {
    setVal({ showRemoveModal: false });
  };

  const deleteWord = async () => {
    try {
      setParam({ loading: true });
        const response = await deleteSensitiveWord(item?.id);

      if (response) {       
        InfoToast("حذف کردن کلمه با موفقیت انجام شد");
        getData();
      } else {        
        InfoToast("حذف کردن کلمه با مشکل مواجه شد");
      }
      
    } catch (err) {
            ErrorToast(err);
    }
    finally {
      setParam({ loading: false });
      setVal({ showRemoveModal: false });
      setParam({ loading: false });
    }
  } 
  
  const close = () => {
    return (
      <span>
        <CloseIcon />
      </span>
    );
  };
  return (
    <Modal
      show={val?.showRemoveModal}
      onHide={handleClose}
      animation={true}
      dir="rtl"
      className="sensitive-word-modal"
    >
      <Modal.Header>
        <Modal.Title
          className="d-flex justify-content-between w-100"
          style={{ fontSize: "16px" }}
        >
          حذف کردن کلمه
          <div onClick={handleClose}>{close()}</div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="sensitive-word-modal-content-view">
        <div>
          <div className="d-flex justify-content-start">
            <div>{`آیا از حذف کردن "${item?.term}" مطمئن هستید؟`}</div>
          </div>
          <div className="d-flex justify-content-center mt-3">
            <button
              className="btn btn-primary"
              onClick={(e) => {
                deleteWord();
              }}
            >
              {param?.loading ? (
                <div
                  className="spinner-border"
                  role="status"
                  aria-hidden="true"
                ></div>
              ) : (
                " حذف کلمه"
              )}
            </button>
            <button
              className="btn btn-default btn-cancel"
              onClick={() => {
                handleClose();
              }}
            >
              انصراف
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default RemoveWord;
